<template>
    <div class="empty-state content-container box">
        <div class="empty-state-content">
            <v-icon :size="iconSize" :color="iconColor" class="empty-state-icon">
                {{ icon }}
            </v-icon>
            <h3 class="empty-state-title">{{ title }}</h3>
            <p class="empty-state-description">{{ description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "EmptyState",
    props: {
        icon: {
            type: String,
            default: "mdi-inbox"
        },
        iconSize: {
            type: [String, Number],
            default: 80
        },
        iconColor: {
            type: String,
            default: "#9E9E9E"
        },
        title: {
            type: String,
            default: "No items found"
        },
        description: {
            type: String,
            default: "There are no items to display at this moment."
        }
    }
};
</script>

<style scoped>
.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    padding: 40px 20px;
    text-align: center;
    border-radius: 10px;
    box-shadow: none !important;
}

.empty-state-content {
    max-width: 400px;
}

.empty-state-icon {
    margin-bottom: 20px;
    opacity: 0.6;
}

.empty-state-title {
    font-size: 20px;
    font-weight: 600;
    color: #424242;
    margin-bottom: 12px;
}

.empty-state-description {
    font-size: 14px;
    color: #757575;
    line-height: 1.5;
    margin: 0;
}
</style>
